import type { ComponentPropsWithRef } from 'react';

import { useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { ExternalLink } from '../Link/ExternalLink';
import { pdfPreviewStyle } from './PdfPreview.css';

type Props = Omit<ComponentPropsWithRef<'object'>, 'data'> & {
  showToolbar?: boolean;
  src: string;
};

export const PdfPreview = ({ showToolbar = true, src, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);

  const data = `${src}#toolbar=${showToolbar ? '1' : '0'}`;

  return (
    <object
      {...delegated}
      aria-label={delegated['aria-label'] ?? delegated.title}
      className={clsx(pdfPreviewStyle, delegated.className)}
      data={data}
      type="application/pdf"
    >
      {/* Fallback shown only when the browser cannot render the PDF inline */}
      <p>
        {t('common:pdfPreview.fallback')} <ExternalLink href={src}>{t('common:pdfPreview.download')}</ExternalLink>
      </p>
    </object>
  );
};
